import { useTheme } from '@pushpay/theming';
export function useThemeColors() {
  const theme = useTheme();
  return {
    accentDark: theme.colors['product-color-dark-200'],
    accentLight: theme.colors['product-color-light-300'],
    greyDark: theme.colors['palette-grey'],
    greyLight: theme.colors['palette-grey-light-100'],
    greyLightest: theme.colors['palette-grey-light-400']
  };
}